<div class="layout-footer" *ngIf="themeData">{{ themeData.theme_slogan || 'footer.title' | translate }}</div>